import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SEO = ({ 
  title, 
  description, 
  canonical, 
  ogImage = '/og-image.jpg',
  type = 'website',
  schema 
}) => {
  const siteUrl = 'https://migarda.co.za';
  const fullUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;
  const fullImageUrl = `${siteUrl}${ogImage}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullImageUrl} />
      
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export const HomePageSEO = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Migarda Investments CC",
    "url": "https://migarda.co.za",
    "logo": "https://migarda.co.za/image2.png",
    "description": "Authorized Telkom franchisee with 45+ stores across South Africa",
    "foundingDate": "2009",
    "numberOfEmployees": "500+",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+27-61-424-7446",
      "contactType": "Customer Service"
    },
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "ZA",
      "addressRegion": "KwaZulu-Natal, Western Cape, Northern Cape"
    },
    "areaServed": ["KZN", "WC", "NC"]
  };

  return (
    <SEO
      title="Migarda Investments | Authorized Telkom Partner | 45+ Stores"
      description="Your trusted Telkom partner with 45+ stores in KZN, Western Cape & Northern Cape."
      canonical="/"
      schema={schema}
    />
  );
};

export const AboutPageSEO = () => (
  <SEO
    title="About Migarda | 15 Years as Telkom Partner"
    description="Since 2009, Migarda has grown from 4 stores to 45+ locations across South Africa."
    canonical="/about"
  />
);

export const LocationsPageSEO = () => (
  <SEO
    title="Store Locations | Find Telkom Stores Near You"
    description="Find your nearest Migarda Telkom store. 45+ locations across South Africa in KZN, Western Cape, and Northern Cape."
    canonical="/locations"
  />
);

export const BusinessPageSEO = () => (
  <SEO
    title="Business Solutions | Telkom Fibre, VoIP, PABX by Migarda"
    description="Empower your business with Telkom solutions from Migarda. Fibre, VoIP, and PABX services for enterprises."
    canonical="/business"
  />
);

export const ContactPageSEO = () => (
  <SEO
    title="Contact Us | Migarda Telkom Support"
    description="Contact Migarda for Telkom support. Call 061 424 7446 or visit our stores."
    canonical="/contact"
  />
);

export const TeamsPageSEO = () => (
  <SEO
    title="Our Team & Culture | Migarda Telkom"
    description="Discover the team culture at Migarda Investments. Meet the people behind 45+ Telkom stores."
    canonical="/teams"
  />
);

export const JobsPageSEO = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "JobPosting",
    "hiringOrganization": {
      "@type": "Organization",
      "name": "Migarda Investments CC"
    },
    "jobLocation": {
      "@type": "Place",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "ZA"
      }
    }
  };

  return (
    <SEO
      title="Careers at Migarda | Join Our Telkom Team"
      description="Explore career opportunities at Migarda. Join our growing team across 45+ stores across South Africa."
      canonical="/jobs"
      schema={schema}
    />
  );
};

export const PrivacyPolicyPageSEO = () => (
  <SEO
    title="Privacy Policy | Migarda Investments"
    description="Read our privacy policy and learn how we protect your personal information at Migarda."
    canonical="/privacy-policy"
  />
);